import { render, staticRenderFns } from "./BotImages.vue?vue&type=template&id=f223d2b2&scoped=true&"
import script from "./BotImages.vue?vue&type=script&lang=js&"
export * from "./BotImages.vue?vue&type=script&lang=js&"
import style0 from "./BotImages.vue?vue&type=style&index=0&id=f223d2b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223d2b2",
  null
  
)

export default component.exports